import { Column } from "@/components/common/Table";
import { CareGapsSchema } from "./careGaps";
import { TruncatedTableCell } from "@/components/common/TruncatedTableCell";

export const columns: Column<CareGapsSchema>[] = [
  {
    key: "metricDescription",
    label: "Metric",
    isSortable: false,
    cellClassName: "lg:w-[313px] md:w-[250px] sm:w-[200px] w-[180px] lg:max-w-[313px] md:max-w-[250px] sm:max-w-[200px] max-w-[180px]",
    headerClassName: "lg:w-[313px] md:w-[250px] sm:w-[200px] w-[180px]",
    render: (row) => {
      const displayText = row.metricDescription && row.metricShort
        ? `${row.metricDescription} (${row.metricShort})`
        : row.metricDescription || row.metricShort || "-";

      return (
        <TruncatedTableCell
          content={displayText}
          className="text-grey-800 dark:text-white"
        />
      );
    },
  },
  {
    key: "metricStatus",
    label: "Status",
    cellClassName: "w-[72px] min-w-[72px] flex-shrink-0",
    headerClassName: "w-auto",
    render: (row) => {
      if (!row.metricStatus) return "-";

      const status = row.metricStatus;
      const isSuccess = status === "Met";

      return (
        <div
          className={`
          inline-flex items-center 
          justify-center
          px-2 py-1 
          rounded-[4px] 
          h-[24px] 
          w-[72px]
          border
          whitespace-nowrap
          flex-shrink-0
          ${isSuccess
              ? "border-green-700 text-green-700"
              : "border-[var(--declined-bg)] text-[var(--declined-bg)]"
            }
        `}
          style={{
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
          }}
        >
          {status}
        </div>
      );
    },
  },
];